import { Inject, Injectable } from '@angular/core';
import { isPresent } from '@imcc/utilities';
import { WINDOW } from '@lib/browser/window-providers';
import { GA_MEASUREMENT_ID } from './ga-measurement-id';
import { GtagConfigParameters } from './gtag-config-paramaters';

@Injectable()
export class AnalyticsService {
  constructor(@Inject(WINDOW) private window: Window) {}

  config(payload: GtagConfigParameters) {
    this.siteTag('config', payload);
  }

  private get siteTag() {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const globalSiteTag = this.window['gtag'];

    if (isPresent(globalSiteTag)) {
      return (...args: any[]) => {
        globalSiteTag(GA_MEASUREMENT_ID, ...args);

        return true;
      };
    }

    return () => false;
  }
}
